module.exports = __webpack_public_path__ + "static/media/sawtooth.e5a6a87e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sawtooth.svg
// module id = 225
// module chunks = 0